export default __webpack_public_path__ + "static/cndf-sessions-4dacb70e261f95080d155ec49e0f5265.png";